<script setup lang="ts">
// The row of list chips above the selected list: one toggle button per
// list with its count of open items. Pressed state is the selected list.
export interface ListChip {
  name: string
  label: string
  openCount: number
}

defineProps<{ lists: ListChip[]; modelValue: string }>()

const emit = defineEmits<{ 'update:modelValue': [name: string] }>()
</script>

<template>
  <div class="flex flex-wrap gap-2" role="group" aria-label="Lists" data-testid="list-chips">
    <button
      v-for="list in lists"
      :key="list.name"
      type="button"
      class="inline-flex min-h-11 items-center gap-1.5 rounded-full border px-3.5 text-[13px] transition-colors sm:min-h-9"
      :class="
        list.name === modelValue
          ? 'border-life bg-life/12 text-ink'
          : 'border-border-control text-ink-muted hover:text-ink'
      "
      :aria-pressed="list.name === modelValue"
      :data-testid="`list-chip-${list.name}`"
      @click="emit('update:modelValue', list.name)"
    >
      {{ list.label }}
      <span class="text-ink-faint">{{ list.openCount }}<span class="sr-only"> open</span></span>
    </button>
  </div>
</template>
